import React, { useState, useCallback } from 'react';
import { IonModal, IonContent, IonButton, IonIcon } from '@ionic/react';
import { chatbubbleEllipsesOutline, peopleOutline, rocketOutline } from 'ionicons/icons';
import { useTranslation } from 'react-i18next';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

interface IntroModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const IntroModal: React.FC<IntroModalProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const [swiper, setSwiper] = useState<any>(null);

  const handleSlideChange = useCallback((swiper: any) => {
    setSwiper(swiper);
  }, []);

  const handleNext = useCallback(() => {
    if (swiper) {
      swiper.slideNext();
    }
  }, [swiper]);

  const handleStart = useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <IonModal isOpen={isOpen} onDidDismiss={onClose} className="intro-modal">
      <IonContent>
        <Swiper
          modules={[Pagination]}
          pagination={{ clickable: true }}
          onSlideChange={handleSlideChange}
          onSwiper={setSwiper}
          className="h-full"
        >
          <SwiperSlide>
            <div className="flex flex-col items-center p-8 h-full justify-center space-y-6">
              <div className="bg-primary/10 rounded-full p-6">
                <IonIcon
                  icon={chatbubbleEllipsesOutline}
                  className="text-6xl text-primary"
                />
              </div>
              <h2 className="text-2xl text-center font-bold text-white">
                {t('intro.slide1.title', 'Apprenez le Russe Naturellement')}
              </h2>
              <p className="text-center text-gray-600 max-w-xs mb-12">
                {t('intro.slide1.description', `Pratiquez la langue avec des tuteurs IA natifs, comme si vous étiez sur place ! Progressez rapidement grâce à des conversations interactives qui s'adaptent à votre niveau et vos objectifs`)}
              </p>
            </div>
            <div className="absolute bottom-8 right-8">
              <IonButton 
                onClick={handleNext}
              >
                {t('intro.next', 'Suivant')}
              </IonButton>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="flex flex-col items-center p-8 h-full justify-center space-y-6">
              <div className="bg-primary/10 rounded-full p-6">
                <IonIcon
                  icon={peopleOutline}
                  className="text-6xl text-primary"
                />
              </div>
              <h2 className="text-2xl font-bold text-white">
                {t('intro.slide2.title', 'Tuteurs Personnalisés')}
              </h2>
              <p className="text-center text-gray-600 max-w-xs mb-12">
                {t('intro.slide2.description', 'Choisissez votre tuteur idéal et progressez à votre rythme')}
              </p>
            </div>
            <div className="absolute bottom-8 right-8">
              <IonButton 
                onClick={handleNext}
              >
                {t('intro.next', 'Suivant')}
              </IonButton>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="flex flex-col items-center p-8 h-full justify-center space-y-6">
              <div className="bg-primary/10 rounded-full p-6">
                <IonIcon
                  icon={rocketOutline}
                  className="text-6xl text-primary"
                />
              </div>
              <h2 className="text-2xl font-bold text-white">
                {t('intro.slide3.title', 'Commencez Maintenant')}
              </h2>
              <p className="text-center text-gray-600 max-w-xs mb-8">
                {t('intro.slide3.description', 'Rejoignez LangueWise et commencez votre voyage vers la maîtrise du russe')}
              </p>
              <IonButton 
                expand="block"
                className="w-full max-w-xs"
                onClick={handleStart}
              >
                {t('intro.getStarted', 'Commencer')}
              </IonButton>
            </div>
          </SwiperSlide>
        </Swiper>
      </IonContent>
    </IonModal>
  );
};

export default IntroModal;
